import { useEffect } from "react";
import { Hooks } from "../layout/utils/hooks";
import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";

const StatsAuditIntegrated = ({language , token}) => {
  const auditToken = useAppSelector((state) => state.LayoutReducer.STAT_AUDIT_URL)
  const {cookies} = GlobalHooks()

  const OPTIONS = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Authorization" : "Bearer "+ cookies.authToken,
    },
  };


  const newStatsAuditIframe = "https:" +
    window.process.env.FO_STATS_URL + "/access_statistics"
    +  "?lng=" + language + "&token=" + token
  
    return (
      <iframe
        id="iframe_statsAudit_display"
        src={newStatsAuditIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsAuditIntegrated